export default "__VITE_ASSET__6ihTTupG__"